<template>
    <div class="jd_home4">
        <!-- Banner Section -->
        <div class="home_header">
            <Swipe
                :loop="false"
                :show-indicators="tabs.length > 1"
                width="100%"
                height="100%"
                :touchable="true"
                ref="swipeItem"
            >
                <SwipeItem v-for="(item, index) in tabs" :key="index">
                    <VanImage :src="item.imgurl || defaultBanner" fit="cover" width="100%" height="100%">
                        <template v-slot:loading>
                            <loading type="spinner" size="20" />
                        </template>
                        <template v-slot:error>
                            <!-- Design Fallback Banner -->
                            <div class="banner_design_fallback">
                                <div class="banner_title">轻装上阵 健康到嘉</div>
                                <div class="banner_subtitle">2026年嘉定区寄递小哥主题线上运动会</div>
                                <div class="banner_date_wrap">
                                    <div class="banner_date">
                                        <i class="clock_icon">🕒</i>
                                        <span>7月1日 - 7月21日</span>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </VanImage>
                </SwipeItem>
                <SwipeItem v-if="tabs.length === 0">
                    <div class="banner_design_fallback">
                        <div class="banner_title">轻装上阵 健康到嘉</div>
                        <div class="banner_subtitle">2026年嘉定区寄递小哥主题线上运动会</div>
                        <div class="banner_date_wrap">
                            <div class="banner_date">
                                <i class="clock_icon">🕒</i>
                                <span>7月1日 - 7月21日</span>
                            </div>
                        </div>
                    </div>
                </SwipeItem>
            </Swipe>
        </div>

        <!-- Body Section (delegated to SportItem for modular logic) -->
        <div class="home_body">
            <SportItem  
                v-if="currentItem || tabs.length > 0"
                :item="currentItem || tabs[0]"
                :items="tabs"
                :sports_id="sportid"
                :detail="detail"
            ></SportItem>   
        </div>
    </div>
</template>

<script>
import "./index.less"
import SportItem from "./item";
import { Image, Loading, Swipe, SwipeItem } from "vant";

export default {
    components: {
        VanImage: Image,
        Loading,
        Swipe,
        SwipeItem,
        SportItem
    },
    watch: {
        item_id(e) {
            this.itemChange();
        },
    },
    data() {
        return {
            currentItem: "",
            tabs: [],
            sportid: this.$route.params.sports_id,
            swiperIndex: 0,
            detail: {},
            item_id: this.$route.params.item_id,
            defaultBanner: "https://oss.mcloud.moveclub.cn/2025/qjyd-hu/%E7%8E%A9%E6%B3%95%E6%94%BB%E7%95%A5.png", // Fallback image
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.init();
        });
    },
    methods: {  
        itemChange: function () {
            if (this.cf.isEmpty(this.item_id)) {
                if (this.tabs.length > 0) {
                    this.item_id = this.tabs[0]['id'];
                    this.$router.replace({ params: { item_id: this.tabs[0]['id'] } });
                }
                return;
            }
            this.currentItem = this.tabs.filter((item) => {
                return +item.id === +this.item_id;
            })[0];
            this.swiperIndex = this.tabs.findIndex(item => +item.id === +this.item_id);
            if (this.swiperIndex < 0) {
                this.swiperIndex = 0;
            }
        },
        init() {
            this.$toast.loading({
                message: "加载中...",
                forbidClick: true,
                duration: 0, 
            });
            this.$api.sports.sportsMain(this.sportid).then(
                (res) => {
                    if (res && res.data && res.data.items) {
                        res.data.items.forEach((item) => {
                            try {
                                if (item.content) {
                                    let arr = JSON.parse(item.content);
                                    item.active = arr[0];
                                    item.noactive = arr[1];
                                }
                            } catch (e) {
                                console.warn("Failed to parse tab content:", e);
                            }
                        });
                        this.tabs = res.data.items;
                        let {
                            bgstyle,
                            id,
                            tabstyle,
                            introstyle,
                            shareconfig,
                            title,
                            is_comment,
                            register_mode,
                            registerform,
                            is_registered,
                            registered_info,
                            luckdraw_acid,
                        } = res.data;
                        try {
                            if (bgstyle) bgstyle = JSON.parse(bgstyle);
                            if (tabstyle) tabstyle = JSON.parse(tabstyle);
                            if (introstyle) introstyle = JSON.parse(introstyle);
                        } catch (e) {
                            console.error(e);
                        }
                        this.detail = {
                            id,
                            bgstyle,
                            tabstyle,
                            introstyle,
                            title,
                            is_comment,
                            register_mode,
                            registerform,
                            is_registered,
                            registered_info,
                            luckdraw_acid: luckdraw_acid || 0,
                        };
                        this.$storage.set("shareInfo", shareconfig);
                        this.itemChange();
                    }
                    if (window.__wxjs_is_wkwebview) {
                        window.scrollTo(0, 1);
                    }
                    this.$toast.clear();
                },
                (e) => {
                    console.error(e);
                    this.$toast.clear();
                }
            );
        }
    }
}
</script>
